export default __webpack_public_path__ + "static/media/zero-grau-mais.0ff947ea.png";